import { render, staticRenderFns } from "./LanguageV2Icon.vue?vue&type=template&id=557c6ad0&scoped=true"
import script from "./LanguageV2Icon.vue?vue&type=script&lang=js"
export * from "./LanguageV2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557c6ad0",
  null
  
)

export default component.exports